/** @format */
import { request } from 'src/utils'
// import { alertData, costData, resourceData } from './testData'

interface subjectParams {
  emails: string
  periods: string[]
  productTypes: string[] | number[]
}

const API = {
  GetResource: '/monitor/?Action=DescribeResourceOverview&Version=2021-01-01', // 概览资源
  GetCostOptOverview: '/monitor/?Action=DescribeCostOptOverview&Version=2021-01-01', // 概览成本中心
  GetNumberOverview: '/monitor/?Action=DescribeAlertNumberOverview&Version=2021-01-01' // 概览告警次数
}

export const GetResource = () => {
  // return resourceData
  return request(API.GetResource, { method: 'get' })
}

// 获取概览
export const GetAlertNumber = (duration: number) => {
  const params = {
    time: Date.parse(String(new Date())) / 1000,
    Duration: duration
  }
  // return alertData
  return request(API.GetNumberOverview, { method: 'get', data: params })
}

// 获取成本接口
export const GetCost = () => {
  // const params = {
  //   page: 1,
  //   pageSize: 10
  // }
  // return costData
  return request(API.GetCostOptOverview, { method: 'get' })
}

export const SubjectCost = (params: subjectParams) => {
  return request('/monitorapi/overviews/SubCostOpt', { method: 'POST', data: params })
}
export default API
